import React from "react";

import {
  Content,
  Title,
} from "@patternfly/react-core";

import {
  getBrand,
  getBrandVariant,
  renderBrandTitle
} from "../services/brandService";

const SchoolHeaderBrand = ({ variant = "desktop" }) => {
  const brand = getBrand();
  const settings = getBrandVariant(variant);

  return (
    <>
      <Title
        headingLevel={brand.headingLevel}
        size={settings.headingSize}
    >
        {renderBrandTitle()}
    </Title>
      {brand.description && (
        <Content component="small">
          {brand.description}
        </Content>
      )}
    </>
  );
};

export default SchoolHeaderBrand;